import React from "react";
import { Volume2, X } from "lucide-react";
import { useClara } from "../contexts/ClaraContext";

export const VoiceToast = () => {
    const { toast, dismissToast } = useClara();
    if (!toast) return null;

    return (
        <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            data-testid="clara-voice-toast"
            style={{ pointerEvents: "none" }}
            className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[calc(100%-32px)] max-w-[448px] z-50 toast-slide"
        >
            <div
                style={{ pointerEvents: "auto" }}
                className="bg-[#1A1A2E] text-white rounded-2xl shadow-2xl border-l-4 border-[#B8860B] flex items-start gap-3 p-4 pr-3"
            >
                <div className="mt-0.5 shrink-0 w-9 h-9 rounded-full bg-[#0A3D7A] flex items-center justify-center">
                    <Volume2 className="w-5 h-5 text-white" aria-hidden="true" />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-[11px] uppercase tracking-[0.18em] font-semibold text-[#E0C875] mb-0.5">
                        Clara
                    </p>
                    <p className="text-base leading-snug text-white">
                        {toast.text}
                    </p>
                </div>
                <button
                    type="button"
                    onClick={dismissToast}
                    aria-label="Dismiss Clara's message"
                    data-testid="clara-toast-dismiss"
                    className="shrink-0 w-9 h-9 rounded-lg hover:bg-white/10 flex items-center justify-center transition-colors"
                >
                    <X className="w-5 h-5" aria-hidden="true" />
                </button>
            </div>
        </div>
    );
};

export default VoiceToast;
